import { Navigate, Route, Routes as SwitchRoutes } from 'react-router-dom';
import React, { lazy } from 'react';
import { MemberPortalRoutes as MemberRoutes, Routes } from 'constants/route.constants';
import CustomRoute from 'memberPortalModules/authentication/containers/CustomRoute/CustomRoute';
import {
  CookiePolicyContainer,
  PrivacyPolicyContainer,
  TermsOfServiceContainer,
} from 'modules/privacy-policy/containers';

const MemberProfileRoute = lazy(() => import('memberPortalModules/MemberProfile/MemberProfile'));
const BookingRoute = lazy(() => import('memberPortalModules/booking/BookingEvents'));
const CatchAllRoute = lazy(() => import('../CatchAll'));

export const MemberPortalRoutes = () => {
  const NotImplemented = () => {
    return (
      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
        <div
          style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#323232',
          }}
        >
          Not implemented yet
        </div>
      </div>
    );
  };

  return (
    <SwitchRoutes>
      <Route path={Routes.HOME} element={<Navigate to={MemberRoutes.PROFILE} />} />
      <Route path={Routes.SIGN_IN} element={<Navigate to={MemberRoutes.PROFILE} />} />

      <Route
        path={Routes.PRIVACY_POLICY}
        element={
          <CustomRoute secure>
            <PrivacyPolicyContainer />
          </CustomRoute>
        }
      />

      <Route
        path={Routes.COOKIE_POLICY}
        element={
          <CustomRoute secure>
            <CookiePolicyContainer />
          </CustomRoute>
        }
      />

      <Route
        path={Routes.TERMS_OF_SERVICE}
        element={
          <CustomRoute secure>
            <TermsOfServiceContainer />
          </CustomRoute>
        }
      />

      <Route
        path={MemberRoutes.PROFILE}
        element={
          <CustomRoute secure>
            <MemberProfileRoute />
          </CustomRoute>
        }
      />

      <Route
        path={MemberRoutes.BOOKING}
        element={
          <CustomRoute secure>
            <BookingRoute />
          </CustomRoute>
        }
      />

      <Route
        path={MemberRoutes.REPORTS}
        element={
          <CustomRoute secure>
            <NotImplemented />
          </CustomRoute>
        }
      />

      <Route
        path={MemberRoutes.CLUBS}
        element={
          <CustomRoute secure>
            <NotImplemented />
          </CustomRoute>
        }
      />

      <Route path="*" element={<CatchAllRoute />} />
    </SwitchRoutes>
  );
};

export default MemberPortalRoutes;
